/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Rapat_S2Inputs */

const en_tut_rapat_s2 = /** @type {(inputs: Tut_Rapat_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave **Aktifkan transkrip otomatis** on if you want automatic notes, and pick the spoken language.`)
};

const id_tut_rapat_s2 = /** @type {(inputs: Tut_Rapat_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biarkan **Aktifkan transkrip otomatis** menyala kalau Anda ingin catatan otomatis, dan pilih **Bahasa percakapan**.`)
};

/**
* | output |
* | --- |
* | "Leave **Aktifkan transkrip otomatis** on if you want automatic notes, and pick the spoken language." |
*
* @param {Tut_Rapat_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_rapat_s2 = /** @type {((inputs?: Tut_Rapat_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Rapat_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_rapat_s2(inputs)
	return en_tut_rapat_s2(inputs)
});